var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 29.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#444;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.2,10c-0.2,0.1-3.2,1.8-3.2,5.6c0,4.4,3.8,5.9,4,6c0,0.1-0.6,2.1-2,4.2c-1.3,1.8-2.6,3.6-4.6,3.6 s-2.5-1.2-4.8-1.2c-2.3,0-3.1,1.2-4.9,1.2s-3.1-1.7-4.6-3.7C1.4,23.3,0,19.5,0,16c0-5.7,3.7-8.8,7.4-8.8c1.9,0,3.6,1.3,4.8,1.3 c1.2,0,3-1.4,5.2-1.4C18.2,7.1,21.2,7.2,23.2,10z M16.3,4.7c0.9-1.1,1.6-2.6,1.6-4.1c0-0.2,0-0.4-0.1-0.6c-1.5,0.1-3.3,1-4.3,2.2 c-0.8,1-1.6,2.5-1.6,4c0,0.2,0,0.5,0.1,0.5c0.1,0,0.2,0,0.4,0C13.7,6.8,15.4,5.9,16.3,4.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.74c6900c02a94ada63d5b274e930b9ee.svg";
export { ForwardRef as ReactComponent };